import React, { Component } from 'react'
import { observer, inject } from 'mobx-react'
import { Link } from 'react-router'
import { up, append } from '../../../../../utils/url'

import ResellerTeamsStore from '../../../../../stores/reseller_teams'
import ResellerMembersStore from '../../../../../stores/resellers'

function serialize(form) {
  return [...form.elements].reduce((data, field) => {
    if (field.name) data[field.name] = field.type === 'checkbox' ? field.checked ? true : false : field.value
    return data
  }, {})
}

@inject('auth')
@observer
export default class ResellerTeamDetails extends Component {
  team = new ResellerTeamsStore()
  
  componentWillMount() {
    const { params: { reseller_team_id } } = this.props
    
    this.team.load(reseller_team_id).then(() => {
      const reseller_team = this.team.findById(reseller_team_id)
      this.members = new ResellerMembersStore({ reseller_team })
      this.members.load().then(() => {
        this.forceUpdate()
      })
    })
  }

  handleSaveResellerTeam = event => {
    event.preventDefault()

    const { params: { reseller_team_id } } = this.props
    const team = this.team.findById(reseller_team_id)
    const updates = serialize(event.target)

    Object.assign(team, updates)

    this.team.update(team)
      .then(() => alert('Success :)'))
      .catch(() => alert('Could not save :('))
  }

  handleSaveResellerMember = id => event => {
    event.preventDefault()

    const member = this.members.findById(id)
    const updates = serialize(event.target)

    Object.assign(member, updates)

    this.members.update(member)
      .then(() => alert('Success :)'))
      .catch(() => alert('Could not save :('))
  }

  render() {
    const { params: { reseller_team_id } } = this.props

    if (!this.team.loaded) return <div className="loading">Loading...</div>

    const team = this.team.findById(reseller_team_id)

    return (
      <div className="container padded team">
        <div className="container">
          <div className="panel full padded">
            <form method="post" onSubmit={this.handleSaveResellerTeam}>
              <h2 className="title"><Link to={up(1)}>Reseller Teams</Link> / <input type="text" name="name" defaultValue={team.name} style={{display: 'inline', width: 'auto'}} /></h2>
              <label style={{display: 'inline', width: 'auto'}}>
                <input type="checkbox" name="broker" defaultChecked={team.broker} />
                {' '}Broker
              </label>
              <input type="submit" value="Save Changes" style={{width: 'auto'}} />
            </form>
          </div>
        </div>

        <div className="container">
          {this.members && this.members.loaded && <div className="panel half padded">
            <h3>Members:</h3>
            <Link to={append('add-member')}>Add New Member</Link>
            <div className="admin-reseller-team-members">
              <div className="admin-reseller-team-members-header">
                <div>Name</div>
                <div>Email</div>
              </div>
              {this.members.map(u => (
                <form key={u.id} onSubmit={this.handleSaveResellerMember(u.id)} className="admin-reseller-team-members-row">
                  <div><input type="text" name="name" defaultValue={u.name} /></div>
                  <div><input type="text" name="email" defaultValue={u.email} /></div>
                  <div><input type="submit" value="Save" /></div>
                </form>
              ))}
            </div>
          </div>}
        </div>

      </div>
    )
  }
}



// WEBPACK FOOTER //
// client/components/sections/Admin/Resellers/Teams/Details.js